import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
// import { Navbar, SideBar } from "./Layouts/MainPage";
// import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import SettingsSidebar, { SettingsSidebarItem } from "../../Layouts/MainPage/SettigsSideBar";
import { Navbar } from "../../Layouts/MainPage";
import Maintanance from "../../Components/Icons/Maintanance";
import Shipping from "../../Components/Icons/Shipping";
import Store from "../../Components/Icons/Store";
import Task from "../../Components/Icons/Task";
import Payments from "../../Components/Icons/Payments";
import Sales from "../../Components/Icons/Sales";
import Procurement from "../../Components/Icons/Procurement";
import Marketing from "../../Components/Icons/Marketing";
import Products from "../../Components/Icons/Products";
import Staff from "../../Components/Icons/Staff";
import UserRole from "../../Components/Icons/UserRole";
import Role from "../../Components/Icons/Role";
import BellIcon from "../../Components/Icons/BellIcon";
import { GetAccess, GetRole, GetSuperAdminRole } from "../../Components/Utils/roles";
import Email from "../../Components/Icons/Email";
import ListIcon from "../../Components/Icons/ListIcon";
import Template from "../../Components/Icons/Template";
import PdfTemplate from "../../Components/Icons/PdfTemplate";
import Signatutre from "../../Components/Icons/Signatutre";
import Reference from "../../Components/Icons/Reference";
import CurrencyIcon from "../../Components/Icons/Currency";
import StatusIcon from "../../Components/Icons/Status";
import PermissionIcon from "../../Components/Icons/Status";
import ProductIcon from "../../Components/Icons/ProfileIcon";
import CompanyInfoIcon from "../../Components/Icons/Company";
import Notes from "../../Components/Icons/Notes";
import CircleCheckIcon from "../../Components/Icons/CircleCheckIcon";
import { FiSliders } from "react-icons/fi";

const MainSettings = () => {
  const location = useLocation();

  const { t } = useTranslation();
  const navItem = [
    {
      icon: <CompanyInfoIcon />,
      title: "Company Info",
      link: '/settings',
      hasAccess: "company_info_view"

    },
    {
      icon: <Products />,

      title: "Products",
      link: '/settings/products',
      hasAccess: "product_view"

    },
    {
      icon: <Marketing />,
      title: "Marketing",
      link: '/settings/marketing',
      hasAccess: "marketing_view"

    },
    {
      icon: <Procurement />,
      title: "Procurement",
      link: '/settings/procurement',
      hasAccess: "procurement_view"

    },
    {
      icon: <CircleCheckIcon color="#999999" width="16" height="16" />,
      title: "PO Checklist",
      link: '/settings/po-checklist',
      hasAccess: "procurement_view"

    },
    {
      icon: <Sales />,
      title: "Sales",
      link: '/settings/sales',
      hasAccess: "sales_view"

    },
    {
      icon: <Payments />,
      title: "Payments",
      link: '/settings/payments',
      hasAccess: "payment_view"

    },
    // {
    //   icon: <Task/>,
    //   title: "Tasks",
    //   link:'/settings/tasks',
    //   hasAccess:"company_info_view"

    // },
    {
      icon: <Store />,
      title: "Store",
      link: '/settings/store',
      hasAccess: "store_view"

    },
    {
      icon: <Shipping />,
      title: "Shipping",
      link: '/settings/shipping',
      hasAccess: "shipping_view"

    },
    {
      icon: <Maintanance />,
      title: "Maintenance",
      link: '/settings/maintenance',
      hasAccess: "maintenance_view"
    },
    {
      icon: <Role />,
      title: "Role",
      link: '/settings/role',
      hasAccess: "role_view"
    },
    {
      icon: <Staff />,
      title: "User",
      link: '/settings/user',
      hasAccess: "user_view"
    },

    {
      icon: <UserRole />,
      title: "User Role",
      link: '/settings/user-role',
      hasAccess: "user_role_view"
    },
    {
      icon: <BellIcon color="#999999" />,
      title: "Notifications",
      link: '/settings/notifications',
      hasAccess: "notification_view"
    },
    {
      icon: <Reference />,
      title: "Reference",
      link: '/settings/reffrence',
      hasAccess: "reference_view"
    },
    {
      icon: <CurrencyIcon />,

      title: "Currency And Vat",
      link: '/settings/currency-vat',
      hasAccess: "reference_view"
    },
    {
      icon: <Signatutre />,
      title: "Seal And Signature",
      link: '/settings/sealandsignature',
      hasAccess: "reference_view"
    },
    {
      icon: <PermissionIcon />,
      title: "Approval Permission",
      link: '/settings/statuspermission',
      hasAccess: "reference_view"
    },
    {
      icon: <PermissionIcon />,
      title: "Approval Limit",
      link: '/settings/approval-limit',
      hasAccess: "reference_view"
    },
    {
      icon: <Email />,
      title: "Email Server",
      link: '/settings/emailserverdetails',
      hasAccess: "reference_view"
    },
    // {
    //   icon: <Email />,
    //   title: "Email Parser",
    //   link: '/settings/email-parser',
    //   hasAccess: "reference_view"
    // },
    {
      icon: <FiSliders className="w-5 h-5 text-slate-500" />,
      title: "Feature Settings",
      link: '/settings/features',
      hasAccess: "reference_view"
    },
    {
      icon: <Template />,

      title: "Template ",
      link: '/settings/template',
      hasAccess: "reference_view"
    },
    {
      icon: <PdfTemplate />,
      title: "PDF Template ",
      link: '/settings/pdfTemplate',
      hasAccess: "reference_view"
    },
    {
      icon: <Notes />,
      title: "PDF Notes",
      link: '/settings/notes',
      hasAccess: "reference_view"
    },
    {
      icon: <ListIcon />,
      title: "Action Log",
      link: '/settings/action-logs',
      onlyAdmin: true
    },
    // {
    //   icon: <Maintanance />,
    //   title: "System Maintenance",
    //   link: '/settings/system-maintenance',
    //   hasAccess: "super_admin_only"
    // }
  ];



  function isActiveFun(x) {
    const currentPath = location.pathname.toLowerCase().replace(/\/$/, "");

    const matchLink = (link) => {
      if (!link) return false;
      const normalizedLink = (link.startsWith("/") ? link : `/${link}`).toLowerCase().replace(/\/$/, "");
      return currentPath === normalizedLink || currentPath.startsWith(normalizedLink + "/");
    };

    if (x?.link && matchLink(x.link)) {
      return true;
    }

    if (x?.hasSubMenu && x?.subMenu) {
      return x.subMenu.some((sub) => matchLink(sub.link));
    }

    return false;
  }

  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <SettingsSidebar>
        {navItem &&
          navItem.map((item) => {
            return (
              <>
                {(() => {
                  const hasAccess =
                    item.hasAccess === "super_admin_only"
                      ? GetSuperAdminRole()
                      : item?.onlyAdmin
                        ? GetRole()
                        : GetAccess(item?.hasAccess);
                  return hasAccess && (
                    <SettingsSidebarItem
                      icon={item?.icon}
                      text={t(item?.title)}
                      hasSubMenu={item?.hasSubMenu}
                      subItem={item?.subMenu}
                      link={item?.link}
                      active={isActiveFun(item)}
                    />
                  );
                })()}
              </>
            );
          })}
      </SettingsSidebar>

      <div className=" flex-1 min-w-0 h-[100vh] ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
        {/* <div className=" w-full h-7 ">
          <p className=' font-semibold text-center text-s text-slate-400'>
            <a
             href="https://numota.in"
             target="_blank"
            >
              &#169;  numota
            </a>
            </p>
        </div> */}
      </div>
    </div>
  );
};

export default MainSettings;